angular.module('bmsApp.employeeTeam')
	.controller('EmployeeGroupSaveCtrl', EmployeeGroupSaveCtrl);

EmployeeGroupSaveCtrl.$inject = [
	'$scope',
	'$state',
	'$q',
	'notify',
	'EmployeeGroupSvc',
];

function EmployeeGroupSaveCtrl(
	$scope,
	$state,
	$q,
	notify,
	EmployeeGroupSvc,
) {
	let self = this;
	let handlers = {};

	self.formvalidatorconfig = {
		submitHandler: function () {
			submit();
		},
		errorPlacement: function (error, element) {
			error.appendTo('#employee-errors');
		},
		errorContainer: '#employee-errors'
	};

	angular.extend(self, {
		loading: true,
		processing: false,
		handlers: handlers,
		form: {},
	});

	this.$onInit = () => {
				if ($state.is('main.employee.index.groups.edit')) {
			self.updating = true;
			EmployeeGroupSvc.read($state.params.groupId).then((response) => {
				self.form = response.data.group;
				self.loading = false;
			});
		}
		else {
			self.updating = false;
			self.loading = false;
		}
	};

	function submit() {
		self.processing = true;
		EmployeeGroupSvc.save(self.form).then((response) => {
			self.processing = false;
			notify({
				message: self.updating ? 'Group updated successfully' : 'Group created successfully'
			});
			$state.go('main.employee.index.groups');
		});
	}

}
